import { render, staticRenderFns } from "./PatientAgreesModal.vue?vue&type=template&id=10ce1f00&scoped=true"
var script = {}
import style0 from "./PatientAgreesModal.vue?vue&type=style&index=0&id=10ce1f00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ce1f00",
  null
  
)

export default component.exports